import http from '../utils/http';

const baseUrl = '/parametros-rastreabilidade';

export default {
    cadastrarConfiguracaoRastreabilidade(data) {
        return http.post({
            url: baseUrl,
            data,
            lockScreen: true,
            notify: {
                status: [400]
            }
        });
    },

    buscarConfiguracoesRastreabilidadePorFiltro(filtro, pageable) {
        return http.post({
            url: `${baseUrl}/filtro/?page=${pageable.page}&size=${pageable.size}`,
            data: filtro,
            lockScreen: true
        });
    },

    buscarConfiguracaoRastreabilidadePadrao() {
        return http.get({
            url: `${baseUrl}/padrao`,
            lockScreen: false
        });
    },

    buscarExcecoesPorIdConfiguracaoEFiltro(idConfiguracao, filtro, pageable) {
        return http.post({
            url: `${baseUrl}/configuracao/${idConfiguracao}/excecoes/filtro/?page=${pageable.page}&size=${pageable.size}`,
            data: filtro,
            lockScreen: true
        });
    },

    findById(idConfiguracaoRastreabilidade) {
        return http.get({
            url: `${baseUrl}/${idConfiguracaoRastreabilidade}`,
            lockScreen: true
        });
    },

    editarConfiguracaoRastreabilidade(data) {
        return http.put({
            url: baseUrl,
            data,
            lockScreen: true,
            notify: {
                status: [400, 500]
            }
        });
    },

    excluirConfiguracaoRastreabilidade(idConfiguracaoRastreabilidade) {
        return http.delete({
            url: `${baseUrl}/${idConfiguracaoRastreabilidade}`,
            lockScreen: true,
            notify: {
                status: [400, 500]
            }
        });
    }
};
